import React, { useEffect, useRef, useState} from 'react';
import { Modal, Button, Spinner, Form } from 'react-bootstrap';
import Select from 'react-select';
import { Formik } from 'formik';
import * as yup from 'yup';
import { setLocale } from 'yup';
import { parse } from 'uuid';

import { ICON_SAVE, ICON_CANCEL } from '../../extras/icons';
import ButtonSpinner from '../../layout/ButtonSpinner';

//Redux
import { useDispatch, useSelector } from 'react-redux';
import { saveLevelsAction, updateLevelsAction } from '../../../actions/levelsActions';
import { listObjectsAction } from '../../../actions/objectsActions';
//Data
import binaries from '../../../data/binaryData';

//Función principal
const LevelForm = props => {
    //Tomo los props
    const { show, handleClose } = props;
    //Genero los refs
    const refDescription = useRef();
    //Datos iniciales
    const initialData = {
        descripcion: '',
        objetos: ''
    }
    //Inicializo el dispatch
    const dispatch = useDispatch();
    //Traigo el store de persona tipos
    const levelsLoading = useSelector( state => state.levels.loadingSave );
    const errorSave = useSelector( state => state.levels.errorSave );
    const isEdit = useSelector( state => state.levels.isEdit );
    const levelSelected = useSelector( state => state.levels.levelSelected );
    const objects = useSelector( state => state.objects.objects );
    //Inicializo el state local
    const [ level, setLevel ] = useState(initialData);
    //Modifico según el cambio
    useEffect(() => {
        //Me fijo si es edición
        if(isEdit && levelSelected){
            setLevel({
                ...levelSelected,
                objetos: levelSelected.objetoList && levelSelected.objetoList.length > 0 ? 
                    levelSelected.objetoList.map(o => ({ value: o.id, label: o.nombre}))
                 : []
            });
        }else{
            setLevel(initialData);
        }
    }, [isEdit, levelSelected, show, objects])
    //Manejo de cambios
    const handleChange = e => {
        setLevel({
            ...level,
            [e.target.name]: e.target.value
        })
    }
    //Manejo cambio del select
    const handleChangeObjetos = (options, values) => {
        //Seteo los datos
        setLevel({
            ...values,
            objetos: options ? options.map(option => (
                {
                    id: option.value,
                    value: option.value,
                    label: option.label
                }
            )) : []
        })
    }
    //Manejo el guardado
    const handleSave = values => {
        //Inicializo los datos
        let data = {
            descripcion: values.descripcion,
            objetoList: level.objetos
        }
        //Verifico si es edición o alta
        if(level.id){
            //Agreo el ID a la data
            data = {
                id: level.id,
                ...data
            }
            //Es edición
            dispatch( updateLevelsAction(data, handleCloseForm) );
        }else{
            //Es creación
            dispatch( saveLevelsAction(data, handleCloseForm) );
        }
    }
    //Manejo cuando se muestra
    const handleOnShow = e => {
        //Me fijo si datos de objetos
        if(!objects){
            dispatch( listObjectsAction() );
        }
        //Pongo el foco en el primer campo
        refDescription.current.focus();
    }
    //Manejo cierre de la ventana
    const handleCloseForm = e => {
        //Reinicio datos
        setLevel(initialData);
        //Cierro
        handleClose();
    }
    //Esquema de validación
    const validationSchema = yup.object({
        descripcion: yup.string().required(),
        objetos: yup.array().nullable()
    });
    //Renderizo
    return (
        <Modal 
            show={show} 
            onHide={handleCloseForm} 
            onShow={handleOnShow} 
            aria-labelledby="contained-modal-title-vcenter" 
            centered
            size="lg"
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    Audiencia Motivo&nbsp;
                    <small><strong>{ isEdit ? 'Editar' : 'Nuevo' } Registro</strong></small>
                </Modal.Title>
            </Modal.Header>
            <Formik
                enableReinitialize
                validationSchema={validationSchema}
                initialValues={{ ...level }}
                onSubmit={ values => handleSave(values) }
            >
                {({
                    handleSubmit,
                    handleChange,
                    handleBlur,
                    values,
                    touched,
                    isValid,
                    errors,
                    isSubmitting
                }) => (
                    <form noValidate onSubmit={handleSubmit} autoComplete="off">
                        <Modal.Body>
                            <div className="row">
                                <Form.Group className="col-md-12">
                                    <label htmlFor="descripcion">Descripción</label>
                                    <Form.Control
                                        id="descripcion"
                                        className="form-control" 
                                        autoFocus 
                                        name="descripcion" 
                                        type="text" 
                                        value={ values.descripcion }
                                        onChange={handleChange}
                                        ref={refDescription}
                                        isInvalid={!!errors.descripcion}
                                        disabled={ levelsLoading }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.descripcion }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-12">
                                    <label htmlFor="objetos">Objetos</label>
                                    <Select
                                        name="objetos"
                                        onChange={options => handleChangeObjetos(options, values)}
                                        isMulti
                                        noOptionsMessage={() => ("No se encontraron datos")}
                                        placeholder="Seleccione"
                                        value={level.objetos}
                                        options={
                                            objects ? (
                                                objects.map(object => (
                                                    {
                                                        value: object.id,
                                                        label: object.nombre
                                                    }
                                                ))
                                            ) : []
                                        }
                                    />
                                </Form.Group>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            {
                                levelsLoading ? (
                                    <ButtonSpinner />
                                ) : (
                                    <Button variant="success" type="submit" disabled={ levelsLoading }>
                                        <ICON_SAVE /> <strong>{ isEdit ? 'ACTUALIZAR' : 'GUARDAR' }</strong>
                                    </Button>
                                )
                            }
                            <Button variant="secondary" onClick={handleCloseForm} disabled={ levelsLoading }>
                                <ICON_CANCEL /> Cancelar
                            </Button>
                        </Modal.Footer>
                    </form>
                )}
            </Formik>
        </Modal>
    );
};

export default LevelForm;